module.exports = "https://web-assets.ifttt.com/packs/media/onboarding_recommendations/onboarding-pro-plus-ab410308.svg";